
import React from 'react';
import { CloudOff } from 'lucide-react';
import { AiStatusIndicator } from './AiStatusIndicator';
import { TopicType } from '@/types/assistant';

interface StatusBannerProps {
  isAiWorking: boolean;
  isLoading: boolean;
  topic: TopicType;
  isOnline: boolean;
}

export const StatusBanner = React.memo(({
  isAiWorking,
  isLoading,
  topic,
  isOnline
}: StatusBannerProps) => {
  return (
    <>
      {/* Floating AI Status Indicator */}
      <AiStatusIndicator 
        isVisible={isAiWorking}
        isLoading={isLoading}
        topic={topic}
      />
      
      {/* Offline Status Indicator */}
      {!isOnline && (
        <div className="absolute top-0 left-0 right-0 bg-yellow-500/90 dark:bg-yellow-700/90 py-1 px-4 text-sm flex items-center justify-center gap-1 z-50">
          <CloudOff className="h-4 w-4" />
          <span>You are offline. Limited functionality available.</span>
        </div>
      )}
    </>
  );
});

StatusBanner.displayName = "StatusBanner";
